import React, { Component, Context } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { WidgetProps } from "../widgets";
import { IStreamState, mapStreamStateToProps } from "../../redux/reducers/stream";
import { IStreamActionDispatches, mapStreamDispatchToProps } from "../../redux/actions/stream";
import { renderGridOrphans } from "../../utils";
import { getDateDisplay, getMonthDateDisplay } from "../../utils/date-utils";
import { IStream } from "../../models/stream";
import { NavLink } from "react-router-dom";
import UISearchInput from "../ui/UISearchInput";
import { UINoData } from "../ui/UIComponents";
import { getContainerWidth } from "../../models/layout";
import ImageView from "../ui/Media/ImageView";
import { FileType } from "../../laco-common/base/models/IFile";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import "./StraightStreams.scss";

type StreamsListState = {
	searchQuery: string;
};

class StreamsList extends Component<IStreamActionDispatches & IStreamState & WidgetProps, StreamsListState> {
	static contextType: Context<ILayoutContext> = LayoutContext;

	state = {
		searchQuery: "",
	};

	get streams(): IStream[] {
		const streams: IStream[] = this.props.streams.filter(
			(stream: IStream) => stream.pageId === this.props.page?.id
		);
		if (this.state.searchQuery)
			return streams.filter((s: IStream) => s.title.toLowerCase().includes(this.state.searchQuery.toLowerCase()));
		return streams;
	}

	componentDidMount() {
		this.props.loadStreams();
	}

	render() {
		const width: number = this.context.settings.isMobileRes ? 300 : 200; // 279 / 368
		const itemsPerRow: number = Math.floor(getContainerWidth() / width);
		const streams: IStream[] = this.streams;
		const rowCount: number = Math.ceil(streams.length / itemsPerRow);
		const orphansToAdd: number = itemsPerRow * rowCount - streams.length;
		const pageUrl: string = `/${this.props.page?.path}/`;
		return (
			<div className="w-100 position-relative straight-streams-container list">
				<div className={clsx(!this.props.isNested && "container", "section-padding pt-5")}>
					<h2>Straight Streams Library</h2>
					<UISearchInput
						className="mb-4 inverted"
						inputStyle={{ minWidth: "275px" }}
						placeholder="Search Straight Streams by name"
						onSearch={(val) => this.setState({ searchQuery: val })}
					>
						{!!this.state.searchQuery && (
							<span className="mt-3 ml-4">
								Showing {streams.length} of {this.props.streams.length}
							</span>
						)}
					</UISearchInput>
					<div className="d-flex flex-row flex-wrap justify-content-around justify-content-lg-between">
						{!streams.length && <UINoData msg="No streams found" />}
						{streams.map((stream: IStream, i: number) => {
							const streamDate: Date = new Date(stream.stream_date);
							return (
								<NavLink to={`/straight-streams/${stream.id}`} key={i} className="scale-in-image-view">
									<div key={stream.id} style={{ maxWidth: width }} className="mb-5 align-self-start">
										<ImageView
											image={{
												filename: stream.thumbUrl,
												fileType: FileType.IMAGE,
												url: stream.thumbUrl,
											}}
											viewWidth={width}
											viewHeight={1.3 * width}
											renderContainer
										/>
										<p className="text-black color-on-hover text-center text-md1 mt-2_5 mb-1">
											{getMonthDateDisplay(streamDate)}
										</p>
									</div>
								</NavLink>
							);
						})}
						{renderGridOrphans(orphansToAdd, <div style={{ width: `${width}px` }} />)}
					</div>
				</div>
			</div>
		);
	}
}

export default connect<IStreamState, IStreamActionDispatches, WidgetProps>(
	mapStreamStateToProps,
	mapStreamDispatchToProps
)(StreamsList);
